import http from "@/services/http";
import { featureFlags } from "@/config/env";
import { mockManager } from "@/services/mock";
import { getSourceId } from "@/utils/constants";

export interface QuestionParams {
  brandId: string;
  categoryId: string;
  days?: number;
  startDay?: string; // 格式：2025-12-30
  endDay?: string; // 格式：2025-12-30
  metricType: string;
  modelId?: string;
  qId?: string; // 问题ID
  page?: number;
  pageSize?: number;
  sourceId?: number; // 数据源ID：2=国内，3=国外
}

export interface QuestionItem {
  taskId: string;
  qId: string;
  question: string;
  modelId: string;
  modelName: string;
  createTime: number;
}

export interface QuestionResponse {
  code: number;
  message: string;
  data: {
    list: QuestionItem[];
    total: number;
    page: number;
    pageSize: number;
  };
}

export const questionApi = {
  async getQuestionList(
    params: QuestionParams
  ): Promise<QuestionResponse["data"]> {
    // 自动添加sourceId，如果没有指定则使用默认值
    const sourceId = params.sourceId ?? getSourceId();

    // 构建请求参数
    const requestParams: QuestionParams = {
      ...params,
      sourceId,
    };

    if (featureFlags.enableMock) {
      return await mockManager.getQuestionList(requestParams);
    }

    try {
      const response = await http.get<QuestionResponse>("data/brand/question", {
        params: requestParams,
      });

      return response.data.data;
    } catch (err) {
      console.error("Question list API error:", err);
      return {
        list: [],
        total: 0,
        page: 1,
        pageSize: 10,
      };
    }
  },
};

export default questionApi;
